import React from 'react'
import {useState, useRef, useCallback} from 'react';

export default function AutocompleteTextInput({
                                                  placeholder,
                                                  value,
                                                  options,
                                                  onChange,
                                                  onOptionClick,
                                                  onEnter,
                                                  classNames,
                                                  onFocusChanged,
                                                  inputClassName,
                                                  hostElement,
                                                  disabled,
                                                  renderOptionFunc
                                              }) {
    const [focused, setFocused] = useState(false);
    const [proposeIndexOfOption, setProposeIndexOfOption] = useState(0);

    const inputRef = useRef(null);

    const handleValueChange = useCallback(newValue => {
        onChange(newValue);
        setProposeIndexOfOption(0);
    });

    const focusChanged = useCallback(e => {
        setFocused(e);
        if (onFocusChanged !== undefined)
            onFocusChanged(e);
    })

    const handleOptionClick = useCallback(option => {
        // onChange(option);
        onOptionClick(option);
    });

    const onEnterHandle = () => {
        const option = options[proposeIndexOfOption];
        // onChange(option);
        onEnter && onEnter(option);
        onOptionClick(option);

        const newProposeIndexOfOption = proposeIndexOfOption > 0 ? proposeIndexOfOption - 1 : 0;
        setProposeIndexOfOption(newProposeIndexOfOption);
    }

    const onKeyDownHandle = () => {
        if (options.length - 1 === proposeIndexOfOption) {
            return;
        }

        setProposeIndexOfOption(proposeIndexOfOption + 1);
    }

    const onKeyUpHandle = () => {
        if (proposeIndexOfOption === 0) {
            return;
        }

        setProposeIndexOfOption(proposeIndexOfOption - 1);
    }

    const handleKeyDown = useCallback(e => {
        switch (e.which) {
            case 13:
                onEnterHandle();
                break;
            case 38:
                onKeyUpHandle();
                break;
            case 40:
                onKeyDownHandle();
                break;
        }
    });

    const onMouseEnter = index => {
        setProposeIndexOfOption(index);
    }

    const renderInputOptions = (options, inputRef) => {
        if (hostElement !== undefined && inputRef.current !== null) {
            let clientRect = ReactDOM.findDOMNode(inputRef.current).getBoundingClientRect();
            let top = clientRect.top + clientRect.height;

            let left = clientRect.left;

            let ss = hostElement.getBoundingClientRect();
            top = top - ss.top;
            left = left - ss.left;
            return ReactDOM.createPortal(
                <div className="autocomplete-input-options portal" hidden={!focused}
                     style={{position: 'absolute', zIndex: '2000', top: top + 'px', left: left + 'px'}}>
                    {options.map((option, index) => (
                        <div key={option.value} onMouseEnter={() => onMouseEnter(index)} id={option.value}
                             className={"portal autocomplete-input-option " + (index === proposeIndexOfOption ? 'propose' : '')}
                             onMouseDown={() => handleOptionClick(option)}>
                            {renderOptionFunc != null ? renderOptionFunc(option) : option.text}
                        </div>
                    ))}
                </div>,
                hostElement
            );
        }


        return (
            <div className="autocomplete-input">
                <div className="autocomplete-input-options" hidden={!focused}>
                    {options.map((option, index) => (
                        <div key={option.value} onMouseEnter={() => onMouseEnter(index)}
                             className={classNames + " autocomplete-input-option " + (index === proposeIndexOfOption ? 'propose' : '')}
                             onMouseDown={() => handleOptionClick(option)}>
                            {renderOptionFunc != null ? renderOptionFunc(option) : option.text}
                        </div>
                    ))}
                </div>
            </div>
        );

    }

    return (
        <div className="autocomplete-input">
            <input
                ref={inputRef}
                disabled={disabled}
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={e => handleValueChange(e.target.value)}
                onFocus={() => focusChanged(true)}
                onBlur={() => focusChanged(false)}
                onKeyDown={handleKeyDown}
                className={inputClassName}
            />

            {options.length > 0 && renderInputOptions(options, inputRef)}
        </div>
    )
}